module.exports = {
      id: "stories-usage",
      viewBox: "0 0 33 27.835",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#stories",
      toString: function () {
        return this.url;
      }
    }